import {
  SET_VARIANT,
  CHANGE_VARIANT_INVENTORY
} from '@/store/mutation-types'
export default {
  [SET_VARIANT] (state, variant) {
    state.variant = variant
  },
  [CHANGE_VARIANT_INVENTORY] (state, data) {
    if (state.variant && state.variant.inventory && data.number && state.variant.id === data.variant_id) {
      let value = state.variant.inventory + data.number
      state.variant.inventory = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/preview/store/mutations.js